var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('a-form', {
    staticStyle: {
      "max-width": "500px",
      "margin": "40px auto 0"
    },
    attrs: {
      "form": _vm.form
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.nextStep.apply(null, arguments);
      }
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "手机/邮箱",
      "labelCol": {
        span: 5
      },
      "wrapperCol": {
        span: 19
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['phone', {
        rules: _vm.validatorRules.phone.rule
      }],
      expression: "['phone',{ rules: validatorRules.phone.rule}]"
    }],
    staticStyle: {
      "width": "270px",
      "margin-left": "-40px"
    },
    attrs: {
      "type": "text",
      "autocomplete": "false",
      "placeholder": "请输入手机号或邮箱"
    }
  })], 1), _vm.show ? _c('a-form-item', {
    attrs: {
      "label": "验证码",
      "labelCol": {
        span: 5
      },
      "wrapperCol": {
        span: 19
      }
    }
  }, [_c('a-row', {
    staticStyle: {
      "margin-left": "2px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    staticClass: "gutter-row",
    attrs: {
      "span": 12
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['captcha', _vm.validatorRules.captcha],
      expression: "['captcha',validatorRules.captcha]"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    }
  })], 1), _c('a-col', {
    staticClass: "gutter-row",
    attrs: {
      "span": 8
    }
  }, [_c('a-button', {
    attrs: {
      "tabindex": "-1",
      "size": "default",
      "readOnly": _vm.state.smsSendBtn
    },
    domProps: {
      "textContent": _vm._s(!_vm.state.smsSendBtn && '获取验证码' || _vm.state.time + ' s')
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.getCaptcha.apply(null, arguments);
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _c('a-form-item', {
    attrs: {
      "wrapperCol": {
        span: 19,
        offset: 5
      }
    }
  }, [_c('router-link', {
    staticStyle: {
      "float": "left",
      "line-height": "40px"
    },
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("使用已有账户登录")]), _c('a-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")])], 1), _c('p', [_vm._v("忘记密码可尝试使用身份证件信息后六位数字登录")])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };